export default __webpack_public_path__ + "static/media/icon-highlight-team.4d529249.svg";